import { getDriver } from "@/tours/driverInstance";
import router from '@/router'

// 대시보드 스텝만 정의
export function buildDashboardSteps(focusIntoView) {
  return [
    {
      element: "#step1",
      popover: {
        title: "제품 현황 요약",
        side: "bottom",
        align: "center",
        description: `
          <div class="ds-tip">
            <div class="item"><span class="num">1</span><div class="txt">
              <div class="tit">총 생산된 제품 수</div>
              <div class="desc">제조 공정이 완료되어 EPCIS에 기록된 제품의 누적 개수입니다.</div>
            </div></div>
            <div class="item"><span class="num">2</span><div class="txt">
              <div class="tit">총 출하된 제품 수</div>
              <div class="desc">생산된 제품 중 물류창고나 유통망으로 출하 처리된 누적 수량입니다.</div>
            </div></div>
            <div class="item"><span class="num">3</span><div class="txt">
              <div class="tit">현재 유통 중인 제품 수</div>
              <div class="desc">최종 목적지 도착 전 상태의 제품 수량입니다.</div>
            </div></div>
            <div class="item"><span class="num">4</span><div class="txt">
              <div class="tit">소매점에 도달한 제품 수</div>
              <div class="desc">소매점(리테일 매장)에 입고 완료된 누적 수량입니다.</div>
            </div></div>
          </div>`
      },
      onHighlightStarted: () => focusIntoView("#step1"),
    },
    {
      element: "#step2",
      popover: {
        title: "이벤트 발생수",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
        <ul class="pb-0 ps-3">
          <li>제조·출하·유통 과정에서 발생한 <b>EPCIS 이벤트</b> 건수입니다.</li>
          <li>최근 추이로 활동량 변화를 확인합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView("#step2"),
    },
    {
      element: "#step3",
      popover: {
        title: "QR 조회수",
        side: "left",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>제품 제조이력 <b>QR스캔 횟수</b>입니다.</li>
          <li>제품의 <b>위조여부 판단</b>에 이용합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView("#step3"),
    },
    {
      element: "#step4",
      popover: {
        title: "제품 목록",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>이미지·GTIN·제조사를 확인하고 <b>상세보기/신규</b> 등록을 진행합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView("#step4"),
    },
    {
      element: "#step5",
      popover: {
        title: "최근 이벤트",
        side: "top",
        align: "center",
        description: `
        <ul class="pb-0 ps-3">
          <li>최근 <b>EPCIS 이벤트</b> 목록 테이블입니다.</li>
          <li>이벤트를 <b>클릭</b>하여 <b>상세이력</b>을 확인할 수 있습니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView("#step5"),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>업무장소 관리메뉴</b>로 이동하시겠어요?
          </div>
            <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
              <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
              <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
                이동
              </button>
            </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'BizLocations' ,query: { tour: 'true' } });
          });
        document.querySelector('#cancel-tour')
          ?.addEventListener('click', () => drv.destroy());
      }
    },
  ];
}
